/**
 * Turns a ranked expense breakdown into donut slices.
 *
 * Input must be the SQL breakdown as it arrives: already sorted by amount, shares already
 * computed. Slices below the cut are grouped into one "rest" slice whose share is what the
 * named ones leave over — clamped at zero, because rounding each share to one decimal can
 * make them sum to a hair over 100.
 */
export function toDonutSlices(slices, options) {
    const maxSlices = Math.max(1, Math.trunc(options.maxSlices));
    const positive = slices.filter((slice) => slice.sharePct > 0);
    if (positive.length === 0)
        return [];
    const named = positive.slice(0, maxSlices).map((slice) => ({
        id: slice.id,
        name: slice.name,
        icon: slice.icon,
        sharePct: slice.sharePct,
        amount: slice.amount,
        isRest: false,
    }));
    if (positive.length <= maxSlices)
        return named;
    const namedShare = named.reduce((total, slice) => total + slice.sharePct, 0);
    const restShare = Math.round(Math.max(0, 100 - namedShare) * 10) / 10;
    if (restShare === 0)
        return named;
    return [...named, { id: null, name: null, icon: null, sharePct: restShare, isRest: true }];
}
//# sourceMappingURL=donut.js.map